import React, { useState } from "react";
import { Card, Button, Modal } from "antd";
import { styled } from "styled-components";
import "../styles.css";
import Ambiente from "./Ambiente";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGear,
  faCashRegister,
} from "@fortawesome/free-solid-svg-icons";
import ParametrosLocais from "./ParametrosLocais";
import Caixas from "./Caixas";
import { useConfigQuery } from "../../../queries/useConfig";

const Sobre = () => {

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const { data: config, error } = useConfigQuery();
  const handleOpenModal = (component) => {
    setModalContent(component);
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
    setModalContent(null);
  };


  const handleContactClick = () => {
    window.open(
      "https://api.whatsapp.com/send?1=pt_BR&phone=5511963697271&text=Olá",
      "_blank"
    );
  };
  const bloquearAcesso = (palavra) => {
    if (!palavra) return false;
    if (config.bloqueiosDoUsuario.toLowerCase().includes(String(palavra).toLowerCase())) {
      return true;
    } else {
      return false;
    }

  };

  return (
    <Container>
      <Card
        style={{
          width: "85%",
          textAlign: "center",
          backgroundColor: "transparent"
        }}
      >
        <center>

          <ButtonStyled
            onClick={() =>
              handleOpenModal(
                <Ambiente handleCloseModal={handleCloseModal} />
              )
            }
             disabled={bloquearAcesso('co.amb')}
            style={{ backgroundColor: "#FFA500" }}
          >
            <FontAwesomeIcon icon={faGear} size="2x" />
            <ButtonText>Ambiente</ButtonText>
          </ButtonStyled>


          <ButtonStyled
            onClick={() =>
              handleOpenModal(
                <ParametrosLocais handleCloseModal={handleCloseModal} />
              )
            }
             disabled={bloquearAcesso('co.par')}
            style={{ backgroundColor: "#000" }}
          >
            <FontAwesomeIcon icon={faGear} size="2x" />
            <ButtonText>Parâmetros</ButtonText>
          </ButtonStyled>


          <ButtonStyled
            onClick={() =>
              handleOpenModal(
                <Caixas handleCloseModal={handleCloseModal} />
              )
            }
            style={{ backgroundColor: "#1677ff" }}
             disabled={bloquearAcesso('co.cai')}
          >
            <FontAwesomeIcon icon={faCashRegister} size="2x" />
            <ButtonText>Caixas</ButtonText>
          </ButtonStyled>


          <ButtonStyled
            onClick={() => handleContactClick()}
            style={{ backgroundColor: "#030556" }}
             disabled={bloquearAcesso('co.sup')}
          >
            <FontAwesomeIcon icon={faGear} size="2x" />
            <ButtonText>Suporte Técnico</ButtonText>
          </ButtonStyled>

        </center>
      </Card>

      <Modal
        visible={isModalVisible}
        onCancel={handleCloseModal}
        footer={null}
        width="100vw"
        bodyStyle={{ padding: 0 }}
        centered
        closeIcon={null}
      >
        <ModalHeader>
          <Button
            type="primary"
            onClick={handleCloseModal}
            style={{
              backgroundColor: "black",
              borderColor: "black"
            }}
          >
            <span>Voltar</span>
          </Button>
        </ModalHeader>

        <ModalBody>{modalContent}</ModalBody>
      </Modal>
    </Container>
  );
};

const ButtonStyled = styled(Button)`
  width: 150px;
  height: 150px;
  border: none;
  border-radius: 10px;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 16px;
  margin: 10px;

  &:disabled {
    opacity: 0.5;
    pointer-events: none;
  }
`;

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: center;
  height: 100vh;
  position: relative;
`;


const ButtonText = styled.span`
  margin-top: 10px;
  font-weight: bold;
`;

const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 0;
  }
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: flex-start;
  padding: 16px;
  background: #fff;
`;

const ModalBody = styled.div`
  padding: 0;
  margin: 0;
  height: calc(100vh - 19vh);
  overflow-y: auto;
`;


export default Sobre;
